import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Slide,
} from '@mui/material';
import {
  TrendingUp,
} from '@mui/icons-material';

const AiRockstar = () => {
  return (
    <Box sx={{ mb: 4 }}>
      <Slide direction="up" in timeout={1200}>
        <Card
          sx={{
            height: 200, 
            borderRadius: 3,
            background: 'linear-gradient(135deg, #0D004A 0%, #1a0b5e 100%)',
            color: 'white', 
            position: 'relative', 
            overflow: 'hidden',
            boxShadow: '0 8px 32px rgba(13, 0, 74, 0.3)', 
            width: '100%',
            '&:hover': {
              transform: 'translateY(-4px)',
              boxShadow: '0 12px 40px rgba(13, 0, 74, 0.4)',
            },
            transition: 'all 0.3s ease',
          }}
        >
          {/* Video Background */}
          <Box
            component="video"
            autoPlay
            loop
            muted
            playsInline
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: 1,
              opacity: 0.3, // Slightly transparent so content is readable
            }}
          >
            <source src="https://jitter.video/file/?id=uE1bM1TPun51tiWU" type="video/mp4" />
            Your browser does not support the video tag.
          </Box>

          {/* Overlay for better text readability */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'linear-gradient(135deg, rgba(13, 0, 74, 0.7) 0%, rgba(26, 11, 94, 0.7) 100%)',
              zIndex: 2,
            }}
          />

          {/* Content */}
          <CardContent 
            sx={{ 
              p: 4, 
              height: '100%', 
              display: 'flex', 
              alignItems: 'center',
              position: 'relative',
              zIndex: 3,
            }}
          >
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1, color: 'white' }}>
                AiRockstar of the Month
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.9, color: 'white' }}>
                Rishabh Gupta
              </Typography>
            </Box>
            <Box
              sx={{
                width: 120, 
                height: 120, 
                borderRadius: '50%',
                backgroundColor: 'rgba(255,255,255,0.1)',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                ml: 3,
                backdropFilter: 'blur(10px)',
                border: '2px solid rgba(255,255,255,0.2)',
              }}
            >
              <TrendingUp sx={{ fontSize: 48, opacity: 0.8 }} />
            </Box>
          </CardContent>
        </Card>
      </Slide>
    </Box>
  );
};

export default AiRockstar;
